/* Aplicação do painel ADMINISTRATIVO — estrutura própria, servida em /admin.
 *
 * Porta separada do painel do cliente: login próprio e uma guarda que só deixa
 * entrar contas de plataforma (as que enxergam todos os tenants). Uma conta de
 * cliente que caia aqui é mandada de volta para o painel da própria empresa.
 *
 * O controle de acesso de verdade é do backend (cada rota exige a permissão e o
 * escopo certos, respondendo 403). Esta guarda é só para levar cada perfil à
 * porta certa, não para autorizar. */

import React from 'react';

import PainelAdmin from './admin/PainelAdmin';
import { Icon } from './admin/ui';
import { useSessao } from './estado/sessao';
import Entrada from './telas/Entrada';

export default function AdminApp() {
  const { autenticado, verificando, usuario, sair } = useSessao();

  if (verificando) {
    return (
      <div className="nebula" style={carregando}>
        <span style={{ color: 'var(--text-muted)', font: 'var(--type-body)' }}>Carregando…</span>
      </div>
    );
  }

  if (!autenticado) {
    return <Entrada />;
  }

  if (!usuario.todos_os_tenants) {
    return (
      <div className="nebula" style={{ ...carregando, backgroundImage: 'var(--canvas-glow)' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, textAlign: 'center', maxWidth: 380 }}>
          <Icon name="shield-check" size={26} style={{ color: 'var(--text-brand)' }} />
          <h1 style={{ margin: 0, font: 'var(--type-h3)' }}>Este acesso é do painel administrativo</h1>
          <p style={{ margin: 0, font: 'var(--type-body)', fontSize: 'var(--fs-body-sm)', color: 'var(--text-muted)' }}>
            Sua conta é de uma empresa. Use o painel da sua empresa para acompanhar conversas, números e campanhas.
          </p>
          <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
            <a href="/" style={acao}>Ir para o painel da minha empresa</a>
            <button type="button" onClick={sair} style={{ ...acao, background: 'transparent', border: '1px solid var(--border-default)', color: 'var(--text-secondary)', cursor: 'pointer' }}>Sair</button>
          </div>
        </div>
      </div>
    );
  }

  return <PainelAdmin usuario={usuario} aoSair={sair} />;
}

const carregando = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100%',
  padding: 24,
  background: 'var(--canvas)',
};

const acao = {
  display: 'inline-flex',
  alignItems: 'center',
  height: 40,
  padding: '0 16px',
  borderRadius: 'var(--radius-control)',
  background: 'var(--accent)',
  color: 'var(--accent-on)',
  font: 'var(--type-body-strong)',
  fontWeight: 'var(--fw-semibold)',
  textDecoration: 'none',
};
